import React from 'react';

import Button from 'widgets/Button';
import FavouritesButton from 'apps/favourites/containers/FavouritesButton';
import Icon from 'widgets/Icon/Icon';

export default class BopFavouritesButton extends FavouritesButton {
  render() {
    const { inFavourites } = this.props;
    return (
      <Button
        className="bop-favouritesButton gn-button"
        type="button"
        onClick={() => {
          if (inFavourites) {
            this.removeFromFavourites();
          } else { this.addToFavourites(); }
        }}
        tertiary
      >
        {inFavourites && (<Icon name="heart-filled" />)}
        {!inFavourites && (<Icon name="heart-empty" />)}
        <span className="bop-favouritesButton__label">
          {inFavourites ? 'Remove from favourites' : 'Add to favourites'}
        </span>
      </Button>
    );
  }
}
